import React, { useState } from 'react';
import { Container, Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Eye, Edit, Trash2, Search } from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../Styles/yellowcalfcss/ExpensesDashboard.css';

const expenseData = [
  { id: 1, expenseNumber: '232', accountType: 'gfdgdf', totalAmount: '0' },
  { id: 2, expenseNumber: '323', accountType: 'gfdgdf', totalAmount: '7' },
  { id: 3, expenseNumber: '3434', accountType: 'gfdgdf', totalAmount: '0' },
  { id: 4, expenseNumber: '5454', accountType: 'gfdgdf', totalAmount: '5' },
  { id: 5, expenseNumber: '76', accountType: 'abharshanh', totalAmount: '1' },
  { id: 6, expenseNumber: 'AF345', accountType: 'test', totalAmount: '6' },
  { id: 7, expenseNumber: 'AF345', accountType: 'test', totalAmount: '4' },
  { id: 8, expenseNumber: 'AF345', accountType: 'test', totalAmount: '3' },
  { id: 9, expenseNumber: 'AF345', accountType: 'test', totalAmount: '4' },
  { id: 10, expenseNumber: 'AF345', accountType: 'test', totalAmount: '9' },
  { id: 11, expenseNumber: 'AF345', accountType: 'test', totalAmount: '0' },
  { id: 12, expenseNumber: 'AF345', accountType: 'test', totalAmount: '0' }
];

export default function ExpensesDashboard() {
  const navigate = useNavigate();
  const [expenseNumberFilter, setExpenseNumberFilter] = useState('');
  const [accountTypeFilter, setAccountTypeFilter] = useState('');
  const [filteredData, setFilteredData] = useState(expenseData);

  const handleExpenseNumberFilter = (value) => {
    setExpenseNumberFilter(value);
    filterData(value, accountTypeFilter);
  };

  const handleAccountTypeFilter = (value) => {
    setAccountTypeFilter(value);
    filterData(expenseNumberFilter, value);
  };

  const filterData = (expenseNumber, accountType) => {
    let filtered = expenseData;
    if (expenseNumber) {
      filtered = filtered.filter(expense =>
        expense.expenseNumber.toLowerCase().includes(expenseNumber.toLowerCase())
      );
    }
    if (accountType) {
      filtered = filtered.filter(expense =>
        expense.accountType.toLowerCase().includes(accountType.toLowerCase())
      );
    }
    setFilteredData(filtered);
  };

  const handleDelete = (id) => {
    const updated = filteredData.filter(item => item.id !== id);
    setFilteredData(updated);
  };

  return (
    <div className="expdash-outer-wrap">
      <Container fluid className="expdash-inner-wrap">

        {/* HEADER */}
        <div className="expdash-header-section" style={{ height: '60px' }}>
          <h3>Expenses</h3>
          <div className="expdash-btn-group">
            <Button className="expdash-action-btn" onClick={() => navigate("/accountant/Type")}>
              Account Type
            </Button>
            <Button className="expdash-action-btn" onClick={() => navigate("/accountant/ExpenseType")}>
              Expense Type
            </Button>
            <Button className="expdash-action-btn" onClick={() => navigate("/accountant/IncomeType")}>
              Income Type
            </Button>
            <Button className="expdash-action-btn">
              Export
            </Button>
          </div>
        </div>

        {/* FILTER SECTION (SEARCH ICON ADDED) */}
        <div className="expdash-filter-section">
          <div className="expdash-filter-inputs" style={{ height: '37px', marginTop: '-10px', width: '500px' }}>

            {/* Expense Number */}
            <div style={{ position: 'relative' }}>
              <Search
                size={14}
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '2px',
                  transform: 'translateY(-50%)',
                  color: '#838080ff'
                }}
              />
              <Form.Control
                type="text"
                placeholder="Filter by Expense Number"
                value={expenseNumberFilter}
                onChange={(e) => handleExpenseNumberFilter(e.target.value)}
                className="expdash-filter-field"
                style={{ paddingLeft: '32px' }}
              />
            </div>

            {/* Account Type */}
            <div style={{ position: 'relative' }}>
              <Search
                size={14}
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '2px',
                  transform: 'translateY(-50%)',
                  color: '#878080ff'
                }}
              />
              <Form.Control
                type="text"
                placeholder="Filter by Account Type"
                value={accountTypeFilter}
                onChange={(e) => handleAccountTypeFilter(e.target.value)}
                className="expdash-filter-field"
                style={{ paddingLeft: '32px' }}
              />
            </div>

          </div>
        </div>

        {/* TABLE HEADER */}
        <div className="expdash-table-header" style={{ marginTop: '4px' }}>
          <div className="expdash-row-layout" style={{ marginLeft: '70px', height: '38px', fontWeight: 'bold' }}>
            <div className="expdash-col-serial" style={{ textAlign: 'center', marginLeft: '-35px' }}>Sr.No</div>
            <div className="expdash-col-expense-num" style={{ textAlign: 'center' }}>Expenses Number</div>
            <div className="expdash-col-account-type" style={{ textAlign: 'center' }}>Account Type</div>
            <div className="expdash-col-total-amount" style={{ textAlign: 'center' }}>Total Amount</div>
            <div className="expdash-col-actions" style={{ textAlign: 'center', marginLeft: '70px' }}>Actions</div>
          </div>
        </div>

        {/* RECORDS */}
        <div className="expdash-records-container">
          {filteredData.map((expense) => (
            <div key={expense.id} className="expdash-record-item" style={{ height: '45px' }}>
              <div className="expdash-row-layout" style={{ marginLeft: '40px', marginTop: '-4px' }}>
                <div className="expdash-col-serial" style={{ textAlign: 'center' }}>{expense.id}</div>
                 <div className="expdash-col-expense-num" style={{ textAlign: 'center' }}>{expense.expenseNumber}</div>
                <div className="expdash-col-account-type" style={{ textAlign: 'center' }}>{expense.accountType}</div>
                <div className="expdash-col-total-amount" style={{ textAlign: 'center' }}>{expense.totalAmount}</div>
                <div className="expdash-col-actions" style={{ marginLeft: '55px', gap: '0px' }}>
                  <button className="expdash-control-btn" onClick={() => navigate(`/accountant/ViewBill/`)}>
                    <Eye size={16} />
                  </button>
                  <button className="expdash-control-btn" onClick={() => navigate(`/accountant/EditBill/`)}>
                    <Edit size={14} />
                  </button>
                  <button className="expdash-control-btn" onClick={() => handleDelete(expense.id)}>
                    <Trash2 size={14} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* SUMMARY */}
        <p className="expdash-summary-text" style={{ marginTop: '20px' }}>
          Showing 1-{filteredData.length} of {filteredData.length} items
        </p>

      </Container>
    </div>
  );
}
